import React from "react";

export const NavigationLinks: React.FC = () => {
  return (
    <div className="md:absolute bottom-0 left-0 flex p-4 gap-3">
      <a
        className="text-secondary-700 text-sm hover:text-primary transition-colors focus:text-primary focus:outline-none focus:underline"
        href="/"
        aria-label="Trang chủ"
        tabIndex={0}
      >
        Trang chủ
      </a>
      <a
        className="text-secondary-700 text-sm hover:text-primary transition-colors focus:text-primary focus:outline-none focus:underline"
        href="/"
        aria-label="Trợ giúp"
        tabIndex={0}
      >
        Trợ giúp
      </a>
    </div>
  );
};
